import React from "react";
import { Box, Typography, BoxProps } from "@mui/material";
import { ReactComponent as ProfilIcon } from "../../public/icons/ProfilIcon.svg";
import ReactSvgIcon from "./ReactSvgIcon";

type ProfilProps = {
    boxProps?: BoxProps;
    onProfilClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export default function Profil({ boxProps, onProfilClick }: ProfilProps) {
    const { sx, ...otherBoxProps } = boxProps || {};
    return (
        <Box
            sx={{
                display: "inline-flex",
                padding: "0.125rem 0.125rem 0.125rem 0.5rem",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "0.5rem",
                borderRadius: "1.25rem",
                background: "#F3F5F6",
                ...sx,
                cursor: "pointer",
            }}
            onClick={onProfilClick}
            {...otherBoxProps}
        >
            <Typography
                sx={{
                    color: "#005499",
                    textAlign: "center",
                    fontFamily: "Roboto",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                }}
            >
                Profil
            </Typography>
            <ReactSvgIcon
                width="1.5rem"
                height="1.5rem"
                ReactIcon={ProfilIcon}
                // reactIconProps={{}}
            />
        </Box>
    );
}
